import { render, staticRenderFns } from "./LPA.vue?vue&type=template&id=5f217614&scoped=true"
import script from "./LPA.vue?vue&type=script&lang=js"
export * from "./LPA.vue?vue&type=script&lang=js"
import style0 from "./LPA.vue?vue&type=style&index=0&id=5f217614&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f217614",
  null
  
)

export default component.exports